module.exports = __webpack_public_path__ + "static/media/IMG_8218.e6c7fd48.JPG";